/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineRuleRegex extends models.TagBaselineRule {
    constructor() {
        super();
        this.setDiscriminator("TagBaselineRuleRegex");
    }

    getFixupPrototypeFunction() { return TagBaselineRuleRegex.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineRuleRegex>): TagBaselineRuleRegex {
        let obj = Object.assign(new TagBaselineRuleRegex(), model);
        TagBaselineRuleRegex.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineRuleRegex>): TagBaselineRuleRegex {
        if (!model) return null;
        return TagBaselineRuleRegex.newInstance(<TagBaselineRuleRegex> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineRuleRegex) {
        if (!obj) return;

        models.TagBaselineRuleRegex.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineRuleRegex): boolean {
        if (models.TagBaselineRule.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagBaselineRuleRegex.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Regular expression for allowed values for this tag
     */
    regex_pattern: string;

}
